import { AnimatePresence, motion } from "framer-motion";
import { collection, getDocs, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";

import DataLoading from "../../Suspense/Loadings/DataLoading/DataLoading";
import { LuSearch } from "react-icons/lu";
import { RxCross2 } from "react-icons/rx";
import SearchItem from "../../Items/Search/SearchItem";
import { db } from "../../../BackEnd/Firebase/Config";

const SearchProducts = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const inputRef = useRef(null);
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isResultsVisible, setIsResultsVisible] = useState(false);
    const resultsRef = useRef(null);
    const clearRef = useRef(null);
    const searchButtonRef = useRef(null);

    const searchVars = {
        initial: {
            width: 0,
            opacity: 0,
        },
        animate: {
            width: "100%",
            opacity: 1,
        },
        whileInView: {
            width: "100%",
            opacity: 1,
        },
    };
    async function fetchData() {
        setLoading(true);
        try {
            if (searchTerm !== "") {
                const q = query(
                    collection(db, "products"),
                    orderBy("productName"),
                    where("productName", ">=", searchTerm),
                    where("productName", "<=", searchTerm + "\uf8ff")
                );

                const [snapShot] = await Promise.all([getDocs(q)]);

                const docs = [];
                snapShot.forEach((doc) => {
                    docs.push(doc.data());
                });

                const filteredResults = docs.filter((product) =>
                    product.productName.startsWith(searchTerm.slice(0, 2))
                );
                setSearchResults(filteredResults);
            } else {
                setSearchResults([]);
            }
            setLoading(false);
        } catch (error) {
            console.error("error fetching search results", error);
            setLoading(false);
        }
    }
    const inputVariants = {
        initial: {
            transformOrigin: "right center",
        },
        whileInView: {
            transformOrigin: "right center",
        },
    };

    function handleInputChange(event) {
        const value = event.target.value;
        setSearchTerm(value);
    }
    function getTextDirection(text) {
        const arabicRegex = /[\u0600-\u06FF]/;

        if (!arabicRegex.test(text)) {
            return "ltr";
        }
        return "rtl";
    }
    const encodeId = (id) => {
        return btoa(id);
    };

    function highlightMatchs(text, searchTerm) {
        const regex = new RegExp(`(${searchTerm})`, "gi");
        const segments = text.split(regex);
        let mergedSegments = [];

        for (let i = 0; i < segments.length; i++) {
            if (segments[i].toLowerCase() === searchTerm.toLowerCase()) {
                if (
                    i > 0 &&
                    typeof mergedSegments[mergedSegments.length - 1] === "string"
                ) {
                    mergedSegments[mergedSegments.length - 1] += segments[i];
                } else {
                    mergedSegments.push(segments[i]);
                }
            } else {
                mergedSegments.push(segments[i]);
            }
        }

        return mergedSegments.map((segment, index) => {
            if (segment.toLowerCase() === searchTerm.toLowerCase()) {
                return (
                    <span key={index} className="font-bold bg-white rounded">
                        {segment}
                    </span>
                );
            } else {
                return segment;
            }
        });
    }
    useEffect(() => {
        fetchData();
        const unsubscribe = onSnapshot(collection(db, "products"), () => {
            fetchData();
        });
        return unsubscribe;
        // eslint-disable-next-line
    }, [searchTerm]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                resultsRef.current &&
                !resultsRef.current.contains(event.target) &&
                inputRef.current &&
                !inputRef.current.contains(event.target) &&
                clearRef.current &&
                !clearRef.current.contains(event.target) &&
                searchButtonRef.current &&
                !searchButtonRef.current.contains(event.target)
            ) {
                setIsResultsVisible(false);
            } else if (inputRef.current && inputRef.current.contains(event.target)) {
                setIsResultsVisible(true);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setIsResultsVisible(!!searchTerm);
    }, [searchTerm]);

    useEffect(() => {
        if (searchTerm) {
            setIsResultsVisible(true);
        } else {
            setIsResultsVisible(false);
        }
    }, [searchTerm]);

    const sliceWords = (text) => {
        let words = text;
        if (text.length > 35) {
            words = `${text.slice(0, 34)}...`;
        } else {
            words = text;
        }
        return words;
    };
    return (
        <div dir="rtl" className="flex flex-col items-center justify-center relative">
            <motion.div
                variants={searchVars}
                initial="initial"
                whileInView="whileInView"
                transition={{
                    duration: 0.9,
                    delay: 0.4,
                }}
                dir="rtl"
                style={{ transformOrigin: "right center" }}
                className="flex items-center justify-center w-full overflow-hidden rounded-full relative 
              border-black border-2"
            >
                <motion.input
                    type="text"
                    value={searchTerm}
                    ref={inputRef}
                    dir={getTextDirection(searchTerm)}
                    onChange={handleInputChange}
                    variants={inputVariants}
                    placeholder="ابحث عن المنتج"
                    className={`flex items-center justify-center pr-5 pl-[3rem] py-2 rounded-md  w-[15rem] 
                    focus:outline-none placeholder:text-right focus:placeholder-transparent`}
                />
                <div
                    className={`absolute left-0 flex items-center justify-center rounded-l-lg w-[2.7rem] h-[2.7rem] 
              bg-yellow-600 border-black
              ${searchTerm === "" ? "text-white " : "text-yellow-500"}
              
              `}
                    dir="rtl"
                >
                    <motion.button
                        whileHover={{ scale: searchTerm === "" ? 1 : 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        ref={searchButtonRef}
                        disabled={searchTerm === ""}
                        onClick={() => fetchData()}
                        className="flex w-full h-full items-center justify-center"
                    >
                        <LuSearch />
                    </motion.button>
                </div>
            </motion.div>
            <AnimatePresence>
                {isResultsVisible && searchTerm && (
                    <div className="absolute top-full left-0 right-0 flex flex-col items-center justify-center 
                     w-full mt-2 z-20">
                        <motion.div
                            dir="rtl"
                            ref={resultsRef}
                            className="flex items-center justify-start flex-col border-2 border-black rounded-lg 
                            w-[15rem] overflow-hidden  max-h-[20rem] overflow-y-scroll 
                            shadow-lg shadow-black bg-stone-300"
                        >
                            {loading ? (
                                <div className="w-full flex items-center justify-center py-3">
                                    <DataLoading color="bg-yellow-500" />
                                </div>
                            ) : searchResults.length > 0 ? (
                                searchResults.map((product, index) => (
                                    <SearchItem product={product}
                                        getTextDirection={getTextDirection}
                                        sliceWords={sliceWords}
                                        highlightMatchs={highlightMatchs}
                                        searchTerm={searchTerm}
                                        index={index}
                                        encodeId={encodeId}
                                        loading={loading}
                                        setIsResultsVisible={setIsResultsVisible}
                                    />
                                ))
                            ) : (
                                <div className="flex items-center justify-center w-full py-3">
                                    <p>لا توجد نتائج</p>
                                </div>
                            )}
                        </motion.div>
                        {searchTerm !== "" ? (
                            <div ref={clearRef} className="flex items-center justify-center p-4">
                                <motion.button
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    onClick={() => setSearchTerm("")}
                                    className="flex items-center justify-center w-8 h-8 rounded-full border-black border-2
                                    shadow-lg shadow-black bg-stone-300
                                    "
                                >
                                    <RxCross2 />
                                </motion.button>
                            </div>
                        ) : null}
                    </div>

                )}
            </AnimatePresence>
        </div>
    );
};

export default SearchProducts;
